<template>
  <div class="page" v-wechat-title="$route.meta.title='离线列表'">
    <div class="list border-box">
      <p class="list-tip">离开本页面后需重新下载缓存！</p>
      <!--<div class="list-li" :class="(index == currIndex && playing==1)?'curr':''" v-for="(item,index) in bagList" @click="playVideoClick(index)" >-->
        <!--{{item.spotname}}-->
        <!--<span class="fr" v-if="voicelist[item.id]==null || voicelist[item.id]==undefined">下载失败</span>-->
        <!--<img class="state" :src="(index == currIndex && playing==1)?require('../../assets/download-pause.png'):require('../../assets/download-play.png')"  alt="" v-if="!(voicelist[item.id]==null || voicelist[item.id]==undefined)">-->
      <!--</div>-->
      <div class="list-li" :class="(index == currIndex && playing==1)?'curr':''" v-for="(item,index) in bagList" @click="playVideoClick(index)" >
        {{item.name}}
        <img class="state" :src="(index == currIndex && playing==1)?require('../../assets/download-pause.png'):require('../../assets/download-play.png')"  alt="" v-if="item.success == true">
        <span class="fr" v-else>下载失败</span>
      </div>
    </div>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>
  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import {getVideoPlay} from "@/service/getData";
  import {wxGetPosition,wxShareme} from '@/utils/wechat'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        userInfo: {}, //用户信息
        lat: this.$route.query.lat || '',
        lng: this.$route.query.lng || '',
        latlng: {lat: '', lng: '' }, //经纬度信息
        cityInfo: {}, //城市信息
        bagList:[],//音频列表
        voicelist: {},//语音离线列表
        total: '',//离线总数
        page: 1,
        rows: 7,
        loadText: "数据加载中",
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: '',

        Audio: '', //音频dom
        playTimer: null, //语音播放计时器
        playTime: 0, //当前播放音频的实时时间
        playing: 0, //是否在播放
        currIndex: -1, //正在播放的语音下标
        currIndex1: 0, //当前播放音频数组下标(用来记录currIndex)

        db: null,//数据库对象
        store: null,//数据库对象
      }
    },
    computed: {

    },
    created() {
      this.global.set_glabalClear();
      let self = this;
      this.$loading.show('数据加载中');
      this.id = this.$route.query.id;
      this.spotid = this.$route.query.spotid;
      this.shopid = this.$route.query.shopid;
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if(this.siteid != "" && this.siteid != null && this.siteid != undefined ){
        setStore("siteid",this.siteid);
      }
      this.userInfo = getStore("userInfo");
      this.sregion = getStore("sregion") || '';

      this.createDB();
    },
    destroyed(){
      if(this.playTimer != null){
        clearInterval(this.playTimer);
        this.currIndex = -1;
        this.playing = 0;
      }
    },
    methods: {
      async initData(){
        let res = await getVideoPlay({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id,
          siteid: this.siteid,
          sregion: this.sregion,
          page:1,
          rows:4
        });

        if (res.errcode === "00000"){
          this.$loading.hide();

          if(!res.data.isbuy){
            this.$router.replace({
              path: `/video-play?${'id='+this.id+'&shopid='+this.shopid+'&appKey='+this.appKey}`
            });
          }else{
            this.bagList = res.data.voiceList;
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }
        }else {
          this.$toast(res.errmsg)
          this.$router.replace({
            path: `/video-play?${'id='+this.id+'&shopid='+this.shopid+'&appKey='+this.appKey}`
          });
        }
      },

      /***本地存储数据库的方法***/
      createDB(){
        let self = this;
        var request = window.indexedDB.open("musicDB");
        request.onerror = function (e) {
          console.log("失败")
        };
        request.onsuccess = function (e) {
          console.log(e);
          self.db = e.target.result;

          var data = {};
          var data1 = [];
          self.store = self.db.transaction(['musicStore'],'readwrite').objectStore('musicStore');
          var req = self.store.openCursor();
          req.onsuccess = function(evt) {
            var cursor = evt.target.result;
            if(cursor){
              var result = evt.target.result.value;
              data[result.mid] = result.url;
              data1.push(result);
              cursor.continue();
            }else {
              self.$loading.hide();
              self.voicelist = data;
              self.bagList = data1;
//              self.initData();
            }
          }
        };
        request.onupgradeneeded = function (e) {
          console.log("数据库更新成功"+e.oldVersion+"----"+e.newVersion);
          self.db = e.target.result; // 获取数据库对象
        }
      },

      //点击语音收听
      playVideoClick: function (index){
        this.playVideo(this,index);
      },

      playVideo: function (self,index){
        var music = self.voicelist[self.bagList[index].mid];

        if(music==null || music==undefined){
          this.$toast("当前音频暂未下载")
          return;
        }

        self.Audio = document.getElementById('Audio');
        if (self.currIndex == index) {
          if (self.Audio.paused) {
            self.Audio.play();
            self.playing = 1;

            self.playVideoTime(self,self.bagList[index].totaltime);
          } else {
            self.Audio.pause();
            self.$loading.hide();
            self.playing = 0;
            if(self.playTimer != null){
              clearInterval(self.playTimer);
            }
          }
        } else {
          self.Audio.play();
          self.playing = 1;
          self.playTime = 0;
          self.currIndex = index;

          setTimeout(function(){
            self.currIndex = index;
            self.Audio.src = music;
            self.Audio.preload = "auto";
            self.Audio.play();
            if(self.Audio.readyState != 4){
              self.$loading.show('音频加载中');
            }
            self.playing = 1;
            self.playVideoTime(self,self.bagList[index].totaltime);

          },100)
        }
      },


      /**
       * 实时监听音频播放进度，播放结束继续播放下一段音频(地图页面)
       * @param self    指向this
       * @param totalTime  当前音频的总时长
       */
      playVideoTime: function (self,totalTime){
        if(self.playTimer != null){
          clearInterval(self.playTimer);
        }
        self.playTimer = setInterval(function () {
          if (self.Audio.currentTime > 0) {
            self.$loading.hide();
          }
          if (self.Audio.currentTime != undefined && !isNaN(self.Audio.currentTime)) {
            self.playTime = (totalTime - self.Audio.currentTime);
          }
        }, 1000);

        self.Audio.onended = function() {  //音频播放结束
          let currIndex = (self.currIndex == self.bagList.length -1) ? 0 : (parseInt(self.currIndex) + 1);
          self.playVideo(self,currIndex);
        };

      },

    },
    components: {},
  }

</script>

<style scoped>
  @import "../../style/view.css";
  .list{padding: 0 .28rem;}
  .list-tip{ padding-top: .2rem; font:.22rem/.4rem "Microsoft YaHei";color:#f30; text-align: center; }
  .list-li{position: relative;height: 1.2rem;font:.3rem/1.2rem "Microsoft YaHei";color:#191919;border-bottom: .01rem solid #f9f9f9;}
  .list-li.curr{color: #ff7328;}
  .state{position: absolute;right: .3rem;top:50%;width: .3rem;height: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .list-li .fr{ font:.22rem/1.2rem "Microsoft YaHei";color:#f30; }
</style>



// WEBPACK FOOTER //
// src/page/download-list/download-list.vue